import {configureStore} from '@reduxjs/toolkit';
import AuthSlice from './slices/AuthSlice';
import ScannerSlice from './slices/ScannerSlice';
import ScreenOrientationSlice from './slices/ScreenOrientationSlice';
import UserRecordSlice from './slices/UserRecordSlice';
import ReviewQuestionsSlice from './slices/ReviewQuestionsSlice';
import ModuleIndexSlice from './slices/ModuleIndexSlice';
import ScratchPadRecordSlice from './slices/ScratchPadRecordSlice';
import CourseIdSlice from './slices/CourseIdSlice';
import ReloadBrowsPageDataSlice from './slices/ReloadBrowsPageDataSlice';
import EnrolledCourseDataSlice from './slices/EnrolledCourseDataSlice';
import MyTrainingRecordSlice from './slices/MyTrainingRecordSlice';
import DashboardRefreshSlice from './slices/DashboardRefreshSlice';
import ResponseAlertSlice from './slices/ResponseAlertSlice';
import DownloadPreferenceSlice from './slices/DownloadPreferenceSlice';
import UserTrainingRecordSlice from './slices/UserTrainingRecordSlice';
import TrackRoot from './slices/TrackRoot';
import AslSlice from './slices/AslSlice';

export const Store = configureStore({
   reducer: {
      userAuth: AuthSlice,
      barcode: ScannerSlice,
      screenOrientation: ScreenOrientationSlice,
      userRecord: UserRecordSlice,
      reviewQuestionAnswer: ReviewQuestionsSlice,
      moduleIndex: ModuleIndexSlice,
      scratchPadRecord: ScratchPadRecordSlice,
      courseId: CourseIdSlice,
      pageReload: ReloadBrowsPageDataSlice,
      enrolledCourseData: EnrolledCourseDataSlice,
      myTrRecord: MyTrainingRecordSlice,
      refreshDashboard: DashboardRefreshSlice,
      responseAlert: ResponseAlertSlice,
      downloadPreference: DownloadPreferenceSlice,
      userTrainingRecordData: UserTrainingRecordSlice,
      TrackRoot: TrackRoot,
      asl: AslSlice,
   },
});
